// extracted by mini-css-extract-plugin
export var article1 = "blog-module--article-1--4115d";
export var article10 = "blog-module--article-10--648f8";
export var article2 = "blog-module--article-2--92b09";
export var article3 = "blog-module--article-3--737f0";
export var article4 = "blog-module--article-4--ce4e9";
export var article5 = "blog-module--article-5--6928c";
export var article6 = "blog-module--article-6--2cb2f";
export var article7 = "blog-module--article-7--fd922";
export var article8 = "blog-module--article-8--a451c";
export var article9 = "blog-module--article-9--4c3fd";
export var articleAuthor = "blog-module--article-author--b53b5";
export var articleCategory = "blog-module--article-category--8d0de";
export var articleDate = "blog-module--article-date--952f0";
export var articleImage = "blog-module--article-image--14e3e";
export var articleInfos = "blog-module--article-infos--e7273";
export var articleReadTime = "blog-module--articleReadTime--8ce25";
export var articleText = "blog-module--article-text--bd2dd";
export var blogSection = "blog-module--blog-section--b399f";
export var headerImage = "blog-module--header-image--abcaa";
export var mainWrapper = "blog-module--main-wrapper--8ab9d";
export var nextPageButton = "blog-module--next-page-button--9ffc3";
export var pageButtonContainer = "blog-module--page-button-container--a83be";